import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/legal-information-hub/page.tsx");
